import { EmptyState } from "@hightouch/htui";
import type { CreativeTaggingNamespace } from "./creative-tagging-status";
import {
  IDLE_STATUS_POLL_MS,
  untaggedMessage,
} from "./creative-tagging-status";
import { useCreativeTaggingStatus } from "./use-creative-tagging-status";

/** Explains why a creative has no tags, from the workspace's latest tagging run. */
export function CreativeTagsEmptyState({
  namespace,
}: {
  namespace: CreativeTaggingNamespace;
}) {
  const { status, isLoading } = useCreativeTaggingStatus(namespace, {
    idlePollMs: IDLE_STATUS_POLL_MS,
  });
  return (
    <EmptyState
      variant="minimal"
      message={isLoading ? "No tags" : untaggedMessage(status)}
    />
  );
}
